import { Link } from "react-router-dom";
import { FaCertificate, FaWater, FaUtensils } from "react-icons/fa6";
import mantas from "../MyDive/mantas.jpeg";
import diver from "../MyDive/diver.jpeg";
import dolphin from "../MyDive/dolphin.jpeg";
import bbq from "../MyDive/bbq.jpeg";
import styles from "./Home.module.css";
import ContactForm from "../../components/ContactForm/ContactForm";
import { Header } from "../../components/Header/Header";
import { Footer } from "../../components/Footer/Footer";

const HIGHLIGHTS = [
  {
    src: diver,
    title: "Daily fun dives",
    body: "Sharks, mantas, wrecks, drifts. Two-tank trips with the best dive sites in the atoll, every day the weather smiles.",
    href: "/my-dive#activities",
    eyebrow: "Activities",
  },
  {
    src: dolphin,
    title: "Sunset dolphin cruise",
    body: "Watch pods of spinners race the boat as the sky turns gold. The Maldives at its most cinematic.",
    href: "/my-dive#activities",
    eyebrow: "Cruises",
  },
  {
    src: bbq,
    title: "Sandbank beach BBQ",
    body: "Pull up to a private sandbank, light the grill, watch the stars come out. The perfect way to end a dive week.",
    href: "/my-dive#activities",
    eyebrow: "Onshore",
  },
];

const VALUE_PROPS = [
  {
    Icon: FaCertificate,
    title: "PADI certified",
    body: "From Discover Scuba to Dive Master — every course taught by professionals with two decades in these waters.",
  },
  {
    Icon: FaWater,
    title: "Floating dive centre",
    body: "Our base sits on the water, surrounded by reef. No long boat rides — you're at the dive site in minutes.",
  },
  {
    Icon: FaUtensils,
    title: "Beyond the dives",
    body: "Sunset cruises, night fishing, sunrise trolling, beach barbecues. The ocean is our playground, day or night.",
  },
];

export const Home = () => {
  return (
    <div className={styles.page}>
      <Header transparent />

      {/* ===================== HERO ===================== */}
      <section className={styles.hero}>
        <img src={mantas} className={styles.heroImg} alt="" />
        <div className={styles.heroOverlay} aria-hidden="true" />
        <div className={styles.heroContent}>
          <span className={styles.heroEyebrow}>MY Adventures · Maldives</span>
          <h1 className={styles.heroTitle}>
            Dive deeper. <em>Live further.</em>
          </h1>
          <p className={styles.heroLede}>
            The Maldives' favourite floating dive centre. Embark on your
            journey to paradise and let the magic of the Maldives unfold
            before your eyes.
          </p>
          <div className={styles.heroCtas}>
            <Link to="/my-dive" className={styles.ctaPrimary}>
              Explore My Dive
            </Link>
            <a href="#contact" className={styles.ctaGhost}>
              Book a trip
            </a>
          </div>
        </div>
        <a href="#story" className={styles.scrollCue} aria-label="Scroll down">
          <span className={styles.scrollDot} />
        </a>
      </section>

      {/* ===================== STORY ===================== */}
      <section id="story" className={styles.story}>
        <div className={styles.section}>
          <span className="eyebrow">Our story</span>
          <h2 className={styles.storyTitle}>
            Twenty years of these waters.
          </h2>
          <p className={styles.storyBody}>
            We're a small team built around two big personalities — Moocho
            and Sajee — who have spent their lives reading the currents,
            chasing the mantas and knowing exactly where to be when the
            sharks come through.
          </p>
        </div>
      </section>

      {/* ===================== VALUE PROPS ===================== */}
      <section className={styles.values}>
        <div className={styles.section}>
          <div className={styles.valueGrid}>
            {VALUE_PROPS.map(({ Icon, title, body }) => (
              <article key={title} className={styles.value}>
                <Icon className={styles.valueIcon} aria-hidden />
                <h3 className={styles.valueTitle}>{title}</h3>
                <p className={styles.valueBody}>{body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ===================== HIGHLIGHTS ===================== */}
      <section className={styles.featured}>
        <div className={styles.section}>
          <div className={styles.sectionHead}>
            <div>
              <span className="eyebrow">Highlights</span>
              <h2 className={styles.featuredTitle}>What we do.</h2>
            </div>
            <Link to="/my-dive" className={styles.sectionLink}>
              All activities <span aria-hidden>→</span>
            </Link>
          </div>
          <div className={styles.featuredGrid}>
            {HIGHLIGHTS.map((h) => (
              <a key={h.title} href={h.href} className={styles.highlightCard}>
                <div className={styles.highlightImage}>
                  <img src={h.src} alt="" loading="lazy" />
                </div>
                <div className={styles.highlightBody}>
                  <span className={styles.highlightEyebrow}>{h.eyebrow}</span>
                  <h3 className={styles.highlightTitle}>{h.title}</h3>
                  <p className={styles.highlightDesc}>{h.body}</p>
                  <span className={styles.highlightCue}>
                    Learn more <span className={styles.highlightArrow}>→</span>
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* ===================== CONTACT ===================== */}
      <section id="contact" className={styles.contact}>
        <div className={styles.contactInner}>
          <div className={styles.contactCopy}>
            <span className="eyebrow">Get in touch</span>
            <h2 className={styles.contactTitle}>Book your next dive.</h2>
            <p className={styles.contactLede}>
              Tell us when you're around, how many of you there are, and
              the kind of adventure you have in mind. We'll come back to
              you with options within a day.
            </p>
          </div>
          <div className={styles.contactCard}>
            <ContactForm />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
